/**
 * Footer events shared between its parts: `lift` (Back to top lifts the wordmark's points) and
 * `pulse` (the skyline fires one scan pulse, used by the end-of-sheet moment).
 */
export type FooterEvent = 'lift' | 'pulse'

const listeners = new Map<FooterEvent, Set<() => void>>()

export const footerBus = {
    emit: (event: FooterEvent): void => {
        listeners.get(event)?.forEach(listener => listener())
    },
    on: (event: FooterEvent, listener: () => void): (() => void) => {
        const set = listeners.get(event) ?? new Set<() => void>()

        set.add(listener)
        listeners.set(event, set)

        return () => {
            set.delete(listener)
        }
    }
}
